import { render } from "./Index.vue?vue&type=template&id=a99b6efc"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render

export default script